/* utm-to-cart.js
   Flawless Theme Version
   - Captures utm_* params from URL
   - Stores them in localStorage
   - Writes to cart attributes via Shopify AJAX API
   - Works for both full cart page and AJAX drawer cart
*/

(function () {
  const STORAGE_KEY = 'cb_utms';
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

  function parseAllUTMs(search) {
    const params = new URLSearchParams(search || '');
    const out = {};
    for (const [k, v] of params.entries()) {
      if (k && k.startsWith('utm_') && v && v.trim() !== '') {
        out[k] = v.trim();
      }
    }
    return out;
  }

  function getStoredUTMs() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function setStoredUTMs(obj) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(obj || {}));
    } catch (e) {}
  }

  async function postCartAttributes(attributes, options = {}) {
    if (!attributes || Object.keys(attributes).length === 0) return false;
    const payload = { attributes: {} };
    for (const k of Object.keys(attributes)) payload.attributes[k] = attributes[k];

    try {
      const fetchOpts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
      };
      if (options.keepalive) fetchOpts.keepalive = true;
      const res = await fetch(ROOT + 'cart/update.js', fetchOpts);
      if (!res.ok) throw new Error('Network response not ok');
      await res.json();
      console.log('UTMs saved to cart attributes', payload.attributes);
      return true;
    } catch (err) {
      console.warn('Failed to save UTMs with fetch', err);
      if (navigator.sendBeacon) {
        const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
        navigator.sendBeacon(ROOT + 'cart/update.js', blob);
        return true;
      }
      return false;
    }
  }

  function saveUTMsNow() {
    const stored = getStoredUTMs();
    if (Object.keys(stored).length) {
      postCartAttributes(stored);
    }
  }

  function attachCheckoutInterception() {
    // Cart page checkout submit
    document.addEventListener('submit', async function (e) {
      const form = e.target;
      if (form.action && form.action.indexOf('/checkout') !== -1) {
        e.preventDefault();
        saveUTMsNow();
        form.submit();
      }
    }, true);

    // Checkout buttons / links
    document.addEventListener('click', function (e) {
      const el = e.target.closest && e.target.closest('a,button,input');
      if (el && el.tagName === 'A' && el.getAttribute('href') && el.getAttribute('href').indexOf('/checkout') === 0) {
        postCartAttributes(getStoredUTMs(), { keepalive: true });
      }
    }, true);
  }

  function attachAjaxCartListeners() {
    // Flawless AJAX cart emits events on window after add-to-cart
    document.addEventListener('ajaxProduct:added', function () {
      saveUTMsNow();
    });

    // If drawer cart checkout button is clicked
    document.addEventListener('click', function (e) {
      const drawerCheckoutBtn = e.target.closest('.cart__checkout, [name="checkout"]');
      if (drawerCheckoutBtn) {
        postCartAttributes(getStoredUTMs(), { keepalive: true });
      }
    });
  }

  async function init() {
    const urlUTMs = parseAllUTMs(window.location.search);
    const stored = getStoredUTMs();
    const merged = Object.assign({}, stored, urlUTMs);

    if (Object.keys(urlUTMs).length) {
      setStoredUTMs(merged);
      await postCartAttributes(merged);
    } else if (Object.keys(stored).length) {
      await postCartAttributes(stored);
    }

    attachCheckoutInterception();
    attachAjaxCartListeners();
  }

  init();
})();
